/* KAKISHIBU – comportamiento de las secciones propias (JS sin librerías). */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- mensajes rotativos de la barra superior ---------- */
  function initRot() {
    $$('[data-kk-rot]').forEach(function (el) {
      if (el.__kk) return; el.__kk = 1;
      var m = Array.prototype.slice.call(el.children); if (m.length < 2) return;
      var i = 0, ms = (parseFloat(el.getAttribute('data-kk-rot')) || 4) * 1000;
      setInterval(function () { m[i].classList.remove('on'); i = (i + 1) % m.length; m[i].classList.add('on'); }, ms);
    });
  }

  /* ---------- cuenta atrás (opcional) ---------- */
  function initCd() {
    $$('[data-kk-cd]').forEach(function (el) {
      if (el.__kk) return; el.__kk = 1;
      var mins = parseFloat(el.getAttribute('data-kk-cd')) || 30, fin = Date.now() + mins * 60000;
      var z = function (n) { return String(n).padStart(2, '0'); };
      function tick() {
        var t = fin - Date.now(); if (t <= 0) { fin = Date.now() + mins * 60000; t = mins * 60000; }
        $('[data-h]', el).textContent = z(Math.floor(t / 36e5));
        $('[data-m]', el).textContent = z(Math.floor(t / 6e4) % 60);
        $('[data-s]', el).textContent = z(Math.floor(t / 1e3) % 60);
      }
      tick(); setInterval(tick, 1000);
    });
  }

  /* ---------- cintas infinitas ---------- */
  function initMq() {
    $$('.js-mq').forEach(function (t) {
      if (t.__kk) return; t.__kk = 1;
      if (reduce) return;
      t.innerHTML += t.innerHTML;
    });
  }

  /* ---------- galería de fotos (flechas + miniaturas) ---------- */
  function initGal() {
    $$('.js-gal').forEach(function (g) {
      if (g.__kk) return; g.__kk = 1;
      var tr = $('.gal__track', g), n = tr.children.length, prev = $('[data-prev]', g), next = $('[data-next]', g);
      var scope = g.closest('.pdp') || document, th = $('.js-thumbs', scope);
      var idx = function () { return Math.round(tr.scrollLeft / tr.clientWidth); };
      var go = function (i) { tr.scrollTo({ left: Math.max(0, Math.min(n - 1, i)) * tr.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); };
      var upd = function () {
        var i = idx(); prev.disabled = i <= 0; next.disabled = i >= n - 1;
        if (th) $$('img', th).forEach(function (t, j) { t.classList.toggle('on', j === i); });
      };
      /* puntitos (solo se ven en móvil, donde no hay flechas) */
      var dots = document.createElement('div'); dots.className = 'gal__dots'; dots.setAttribute('aria-hidden', 'true');
      for (var d = 0; d < n; d++) dots.appendChild(document.createElement('i'));
      g.appendChild(dots);
      var updDots = function () { var i = idx(); Array.prototype.forEach.call(dots.children, function (x, k) { x.classList.toggle('on', k === i); }); };
      tr.addEventListener('scroll', updDots, { passive: true }); updDots();
      prev.addEventListener('click', function () { go(idx() - 1); });
      next.addEventListener('click', function () { go(idx() + 1); });
      tr.addEventListener('scroll', upd, { passive: true }); upd();
      if (th) th.addEventListener('click', function (e) {
        var t = e.target;
        if (t.getAttribute && t.getAttribute('data-i') !== null) go(parseInt(t.getAttribute('data-i'), 10));
        else if (t.hasAttribute && t.hasAttribute('data-prev')) go(idx() - 1);
        else if (t.hasAttribute && t.hasAttribute('data-next')) go(idx() + 1);
      });
    });
  }

  /* ---------- carruseles genéricos ---------- */
  function initCar() {
    $$('.car').forEach(function (car) {
      if (car.__kk) return; car.__kk = 1;
      var tr = $('.car__track', car); if (!tr) return;
      var items = Array.prototype.slice.call(tr.children), dots = $('.car__dots', car), prev = $('[data-prev]', car), next = $('[data-next]', car);
      if (dots) dots.innerHTML = items.map(function () { return '<i></i>'; }).join('');
      var step = function () { return items[0].getBoundingClientRect().width + 14; };
      var upd = function () {
        var i = Math.round(tr.scrollLeft / step());
        if (dots) Array.prototype.forEach.call(dots.children, function (x, j) { x.classList.toggle('on', j === Math.min(i, items.length - 1)); });
        if (prev) prev.disabled = tr.scrollLeft < 5;
        if (next) next.disabled = tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 5;
      };
      if (prev) prev.addEventListener('click', function () { tr.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { tr.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
      tr.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
    });
  }

  /* ---------- tarjetas de beneficios que se abren ---------- */
  function initBnf() {
    $$('.bnf__c').forEach(function (c) {
      if (c.__kk) return; c.__kk = 1;
      c.addEventListener('click', function () { c.classList.toggle('open'); });
    });
  }

  /* ---------- sello de garantía ---------- */
  function initBurst() {
    $$('.js-burst').forEach(function (svg) {
      if (svg.__kk) return; svg.__kk = 1;
      var p = '', n = 24, i, a, r;
      for (i = 0; i < n; i++) { a = i / n * Math.PI * 2 - Math.PI / 2; r = i % 2 ? 42 : 50; p += (i ? 'L' : 'M') + (50 + r * Math.cos(a)).toFixed(2) + ' ' + (50 + r * Math.sin(a)).toFixed(2); }
      svg.innerHTML = '<path d="' + p + 'Z" fill="var(--c)" stroke="var(--c)" stroke-width="6" stroke-linejoin="round"/>';
    });
  }

  /* ---------- fechas de entrega (días hábiles) ---------- */
  function businessDay(n) {
    var d = new Date();
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; }
    return d.toLocaleDateString(document.documentElement.lang || 'es', { day: 'numeric', month: 'short' });
  }
  function initDeliv() {
    $$('.deliv[data-days]').forEach(function (el) {
      var n = parseInt(el.getAttribute('data-days'), 10) || 0, f1 = $('.js-f1', el);
      if (!f1) return;
      var d = new Date(); d.setDate(d.getDate() + n);
      f1.textContent = d.toLocaleDateString(document.documentElement.lang || 'es', { day: 'numeric', month: 'long' });
    });
  }

  /* ---------- bloque de compra: packs, suscripción, precio y botón ---------- */
  function initBuy() {
    $$('.js-buy').forEach(function (root) {
      if (root.__kk) return;
      var form = $('form.kk-form', root), dataEl = $('[data-kk-data]', root);
      if (!form || !dataEl) return; root.__kk = 1;
      var data = JSON.parse(dataEl.textContent), by = {};
      data.forEach(function (d) { by[d.id] = d; });
      var idInput = $('[data-kk-id]', form), planInput = $('[data-kk-plan]', form);
      var offersBox = $('.js-offers', root), offers = $$('.offer', root);
      var savePrefix = root.getAttribute('data-save') || 'Ahorra';
      var state = { id: parseInt(idInput.value, 10), sub: false };
      offers.forEach(function (o) {
        var p = $('.offer__p', o), s = $('.offer__s', o);
        o.__p = p ? p.textContent : ''; o.__s = s ? s.textContent : '';
      });
      function paint() {
        var d = by[state.id]; if (!d) return;
        var sub = state.sub && d.plan;
        offers.forEach(function (o) {
          var vid = parseInt(o.getAttribute('data-vid'), 10), dd = by[vid], on = vid === state.id;
          o.classList.toggle('is-sel', on); o.setAttribute('aria-checked', on ? 'true' : 'false');
          if (dd) {
            var p = $('.offer__p', o), u = $('.offer__u', o), useSub = state.sub && dd.plan;
            if (p) p.textContent = useSub ? dd.subPrice : dd.price;
            if (u && dd.unit) u.textContent = useSub ? dd.subUnit : dd.unit;
          }
        });
        $$('.pt__o', root).forEach(function (o) { o.classList.toggle('is-sel', (o.getAttribute('data-sub') === '1') === !!sub); });
        var price = sub ? d.subPrice : d.price;
        $$('[data-pp],[data-ap]', root).forEach(function (el) { el.textContent = price; });
        $$('[data-pc],[data-ac]', root).forEach(function (el) { el.textContent = d.compare; });
        $$('[data-pb-badge]', root).forEach(function (el) { el.hidden = !d.save; el.textContent = d.save ? savePrefix + ' ' + d.save : ''; });
        idInput.value = d.id; if (planInput) planInput.value = sub ? d.plan : '';
        var btn = $('.atc', form), lbl = $('[data-atc-label]', form);
        if (btn) btn.disabled = !d.available;
        if (lbl) lbl.textContent = d.available ? offersBox.getAttribute('data-btn') : offersBox.getAttribute('data-sold-out');
        var detail = { d: d, price: price, sub: !!sub }; root.__last = detail;
        root.dispatchEvent(new CustomEvent('kk:pack', { detail: detail }));
      }
      offers.forEach(function (o) {
        var choose = function () { state.id = parseInt(o.getAttribute('data-vid'), 10); paint(); };
        o.addEventListener('click', choose);
        o.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(); } });
      });
      $$('.pt__o', root).forEach(function (o) { o.addEventListener('click', function () { state.sub = o.getAttribute('data-sub') === '1'; paint(); }); });
      paint();
    });
  }

  /* ---------- barra de compra fija (aparece al pasar el botón principal) ---------- */
  function initSticky() {
    var bar = $('[data-kk-sticky]'); if (!bar || bar.__kk) return; bar.__kk = 1;
    var main = $('[data-kk-main]'), pdp = $('.pdp'); if (!main || !pdp) return;
    var vis = new Map();
    var upd = function () {
      var any = false; vis.forEach(function (v) { if (v) any = true; });
      var on = !any && pdp.getBoundingClientRect().top < 0;
      bar.classList.toggle('on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { vis.set(e.target, e.isIntersecting); }); upd(); });
      $$('.js-buy form .atc').forEach(function (b) { io.observe(b); });
    }
    window.addEventListener('scroll', upd, { passive: true });
    var apply = function (det) {
      if (!det) return;
      var k = $('[data-st-pack]', bar), p = $('[data-st-p]', bar), c = $('[data-st-c]', bar), btn = $('[data-st-btn]', bar);
      if (k) k.textContent = det.d.title + (det.sub ? ' · suscripción' : '');
      if (p) p.textContent = det.price;
      if (c) c.textContent = det.d.compare || '';
      if (btn) btn.disabled = !det.d.available;
    };
    main.addEventListener('kk:pack', function (e) { apply(e.detail); });
    apply(main.__last);
    var go = $('[data-st-btn]', bar);
    if (go) go.addEventListener('click', function () {
      var f = $('form.kk-form', main), s = f && $('.atc', f);
      if (f && f.requestSubmit) f.requestSubmit(s); else if (f) f.submit();
    });
  }

  /* ---------- línea de tiempo animada (ritual) ---------- */
  function initTl() {
    $$('[data-kk-tl]').forEach(function (tl) {
      if (tl.__kk) return; tl.__kk = 1;
      var steps = $$('.tl__s', tl); if (!steps.length) return;
      tl.classList.add('is-anim');
      var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      var ticking = false, track = 0;
      function measure() {
        var last = steps[steps.length - 1];
        track = Math.max(0, last.offsetTop + 14 - 8);
        tl.style.setProperty('--tl-track', track + 'px');
      }
      function update() {
        ticking = false;
        var r = tl.getBoundingClientRect(), marker = window.innerHeight * 0.62 - r.top;   /* punto de lectura en pantalla */
        var h = still ? track : Math.max(0, Math.min(track, marker - 8));
        tl.style.setProperty('--tl-h', h + 'px');
        steps.forEach(function (s) { s.classList.toggle('is-on', still || marker >= s.offsetTop + 14 - 40); });
      }
      function req() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
      measure(); update();
      window.addEventListener('scroll', req, { passive: true });
      window.addEventListener('resize', function () { measure(); req(); });
      window.addEventListener('load', function () { measure(); req(); });
    });
  }

  function init() {
    initTl(); initRot(); initCd(); initMq(); initGal(); initCar(); initBnf(); initBurst(); initBuy(); initDeliv(); initSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* editor de temas de Shopify: volver a iniciar al recargar una sección */
  document.addEventListener('shopify:section:load', init);
})();

/* Cifras: los números cuentan desde 0 cuando entran en pantalla */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function parse(el) {
    var m = (el.textContent || '').match(/^(\D*?)([\d][\d.,]*)(.*)$/);
    if (!m) return null;
    var raw = m[2], dec = /[.,]\d{1,2}$/.test(raw) ? raw.split(/[.,]/).pop().length : 0;
    var val = parseFloat(raw.replace(/[.,](?=\d{3}\b)/g, '').replace(',', '.'));
    return isNaN(val) ? null : { pre: m[1], val: val, suf: m[3], dec: dec, orig: el.textContent };
  }
  function run(el, d) {
    var t0 = Date.now(), dur = 1800;
    function fmt(v) { return d.pre + v.toFixed(d.dec).replace('.', ',') + d.suf; }
    var iv = setInterval(function () {
      var p = Math.min(1, (Date.now() - t0) / dur), e = 1 - Math.pow(1 - p, 3);
      el.textContent = p >= 1 ? d.orig : fmt(d.val * e);
      if (p >= 1) clearInterval(iv);
    }, 30);
  }
  var timer = null;
  function check() {
    var pend = [].slice.call(document.querySelectorAll('.stats__n[data-kk-count="1"]'));
    if (!pend.length) { clearInterval(timer); timer = null; return; }
    pend.forEach(function (el) {
      var r = el.getBoundingClientRect(), h = window.innerHeight || document.documentElement.clientHeight;
      if (r.width && r.top < h * 0.92 && r.bottom > 0) {
        el.setAttribute('data-kk-count', '2');
        var d = parse(el.getAttribute('data-kk-orig') ? { textContent: el.getAttribute('data-kk-orig') } : el);
        if (d) run(el, d);
      }
    });
  }
  function init() {
    if (reduce) return;
    var els = [].slice.call(document.querySelectorAll('.stats__n:not([data-kk-count])'));
    els.forEach(function (el) {
      var d = parse(el); if (!d) return;
      el.setAttribute('data-kk-orig', d.orig);
      el.setAttribute('data-kk-count', '1');
      el.style.fontVariantNumeric = 'tabular-nums';
      el.textContent = d.pre + (0).toFixed(d.dec).replace('.', ',') + d.suf;
    });
    if (els.length && !timer) timer = setInterval(check, 150);
    check();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
